export const stats = [
  { value: '+640', label: 'Schede e attività pronte da stampare' },
  { value: '+1.500', label: 'Insegnanti di danza soddisfatti in Europa' },
  { value: '3.800+', label: 'Ore di preparazione risparmiate ogni mese' },
  { value: '98%', label: 'Tasso di raccomandazione tra i professionisti' },
]

export const differenceStats = [
  { value: '+640', label: 'Unità e attività di movimento (tutti i livelli)' },
  { value: '6', label: 'Volumi digitali completi (curriculum integrale)' },
  { value: '100%', label: 'Download digitale immediato' },
]

export const beforeItems = [
  'Domeniche perse: ore passate a pianificare ogni singola lezione da zero',
  'Esercizi improvvisati: combinazioni che non fluiscono per mancanza di supporti visivi',
  'Progressi frammentati: nessuna connessione tecnica chiara tra le diverse età',
  'Incubi di valutazione: difficoltà a tracciare i progressi o creare certificati seri',
  'Burnout: sentirsi mentalmente sovraccarichi prima ancora che inizi la musica',
]

export const afterItems = [
  'Preparazione in 5 minuti: ripassa il materiale ed entra in studio con totale fiducia',
  'Laboratori di movimento: attività creative ed esercizi tecnici con istruzioni passo dopo passo',
  'Mappe visive della danza: infografiche ad alta risoluzione su anatomia e tecnica integrate',
  "Valutazioni pronte all'uso: schede, tracker e certificati 100% pronti da stampare",
  'Visione unificata: un sistema completo per pianificare meno e insegnare con più passione',
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Volumi per tutte le età',
    text: 'Un curriculum progressivo completo da «La Scintilla Creativa» (4-6 anni) fino all\u2019Eccellenza Professionale (14+ anni)',
  },
  {
    emoji: '🎭',
    title: 'Kit Coreografia e Performance',
    text: 'Schede tecniche per costruire routine, esercizi di presenza scenica e guide all\u2019organizzazione delle prove',
  },
  {
    emoji: '✏️',
    title: 'Script per Insegnanti «Ready-to-Go»',
    text: 'Suggerimenti professionali che ti dicono esattamente come spiegare movimenti complessi a ogni fascia d\u2019età',
  },
  {
    emoji: '📐',
    title: 'Danza Visuale: Infografiche e Poster',
    text: 'Grafiche in risoluzione 8K per rendere l\u2019allineamento, l\u2019anatomia e le posizioni facili da capire',
  },
  {
    emoji: '📊',
    title: 'Strumenti di Valutazione e Inclusione',
    text: 'Checklist delle abilità, tracker degli studenti e versioni semplificate per l\u2019insegnamento inclusivo',
  },
]

export const bonuses = [
  {
    title: 'Calendario Didattico 12 Mesi™',
    was: '19€',
    text: 'Organizza i 6 volumi in un piano di insegnamento annuale chiaro e professionale',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/9c4dd00a-bb73-4699-a0bd-6f8821d8e506.jpg',
  },
  {
    title: 'Starter Kit Prima Settimana™',
    was: '27€',
    text: 'Tutto per una prima impressione perfetta: attività di benvenuto, routine e strumenti di setup',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/888c602a-eed1-49c3-827b-c7b163cc286c.jpg',
  },
  {
    title: 'Pack Comunicazione Genitori™',
    was: '36€',
    text: 'Template professionali per tenere i genitori informati e soddisfatti dei progressi dei figli',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0edfcefa-f64c-4145-b8db-ae97ba162dd8.jpg',
  },
  {
    title: 'Studio Binder Kit™',
    was: '17€',
    text: 'Il sistema di organizzazione definitivo per tenere tutto il curriculum in un unico raccoglitore fisico',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/8166ac32-4517-4abf-8ac3-e97c90b2fcd1.jpg',
  },
  {
    title: 'Test di Livello Rapido™',
    was: '17€',
    text: 'Valuta e inserisci ogni allievo nel livello giusto con assoluta sicurezza',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b76f4aed-1154-40b3-bc07-e301ca30c0f4.jpg',
  },
]

export const offerRows = [
  { label: '6 Volumi Digitali (Curriculum Completo)', value: '77€' },
  { label: '5 Bonus Strategici Esclusivi', value: '116€' },
]

export const testimonials = [
  {
    quote:
      'Finalmente ho riavuto i miei weekend. Le lezioni sono progressive e i bambini adorano le schede visive.',
    name: 'Silvia M.',
    location: 'Titolare di Accademia 🇮🇹',
  },
  {
    quote:
      'Le mappe tecniche sono una svolta per i miei allievi visivi. Materiale davvero professionale.',
    name: 'Marco B.',
    location: 'Insegnante di Danza Classica 🇮🇹',
  },
  {
    quote:
      'Dai piccoli al mio team agonistico, questo è il miglior investimento che abbia fatto per le mie classi.',
    name: 'Elena V.',
    location: 'Insegnante Freelance 🇮🇹',
  },
]
